<ng-template #content>
  <div class="flex flex-col w-full h-full">
    <ng-content></ng-content>
  </div>
</ng-template>
